import React, { useEffect, useState } from "react";

const getUniqueColor = (label) => {

  const colorCodes = {
    "All": "#536493",
    "In Progress": "#6F6EDE",
    "Action Required": "#F26666",
    "Requested Follow Up": "#FABC3F",
    "Qualified": "#15B392",
    "Booked": "#66D062",
    "DNQ Criteria Not Met": "#CBA35C",
    "DNQ Other": "#CBA35C",
    "DNQ No Response": "#CBA35C",
    "DNQ Not Interested": "#CBA35C",
    "Non-textable": "#D73A60",
    "To-call": "#605EA1",
    "Contact Attempt 1": "#F28E58",
    "Contact Attempt 2": "#F28E58",
    "Contact Attempt 3": "#F28E58",
    "Scheduled Screen": "#AA5486",
    "Skipped": "#B91C1C",
  };
  
  return colorCodes[label] || "#536493";
};

const AutoColorChangingSVG = ({ count, label, selected }) => {
  const [hover, setHover] = useState(false);
  const [bgColor, setBgColor] = useState("#536493");
  useEffect(() => {
    setBgColor(getUniqueColor(label));
  }, [label]);

  const width = Math.max(28, (count ? count.toString().length : 0) * 10 + 10);

  useEffect(()=>{

  },[selected])

  return (
    <div
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      {hover || selected ? (
        <svg
          width={width}
          height="28"
          viewBox={`0 0 ${width} 28`}
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width={width} height="28" rx="8" fill={bgColor} />
          <text
            x="50%"
            y="50%"
            fill="white"
            fontSize="10"
            textAnchor="middle"
            dy=".3em"
            className="font-[500] text-[14px]"
          >
            {count}
          </text>
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={width}
          height="28"
          viewBox={`0 0 ${width} 28`}
          fill="none"
        >
          <rect
            x="0.5"
            y="0.5"
            width={width - 1}
            height="27"
            rx="7.5"
            fill="white"
          />
          <rect
            x="0.5"
            y="0.5"
            width={width - 1}
            height="27"
            rx="7.5"
            stroke={bgColor}
          />
          <text
            x="50%"
            y="50%"
            fontSize="14"
            fontWeight="bold"
            fill={bgColor}
            textAnchor="middle"
            alignmentBaseline="middle"
          >
            {count}
          </text>
        </svg>
      )}
    </div>
  );
};

export default AutoColorChangingSVG;
